import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { delay, map } from 'rxjs/operators';
import { Globals } from 'src/app/globals/globals';

@Injectable({
  providedIn: 'root'
})
export class TenantUserService {
  constructor(public http: HttpClient, public globals: Globals) { }
  public getUsers(data): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_View')) {
    return this.http.post(environment.serviceurl+'/TenantUser/search',data);
  } else {
    return from([]);
  }
  }
  public ActivateUser(user_guid):Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Activate')) {
    return this.http.get(environment.serviceurl+'/TenantUser/'+ user_guid);
  } else {
    return from([]);
  }
  }
  
  public deleteUser(user_guid): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Delete')) {
    return this.http.delete(environment.serviceurl+'/TenantUser/'+ user_guid);
  } else {
    return from([]);
  }
  }
  public setUser(data): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Create') || this.globals.workspaceActions.includes('TenantUsers_Edit')) {
    return this.http.post(environment.serviceurl+'/TenantUser', data);
  } else {
    return from([]);
  }
  }
  public toggleUserLock(user_guid): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Activate')) {
    return this.http.post(environment.serviceurl+'/TenantUser/'+ user_guid +'/lock-toggle', {});
  } else {
    return from([]);
  }
  }
  public unlockUser(user_guid): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Activate')) {
    return this.http.post(environment.serviceurl+'/TenantUser/'+ user_guid +'/unlock', {});
  } else {
    return from([]);
  }
  }
  public resetUserPassword(user_guid, newPassword): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Edit')) {
    return this.http.post(environment.serviceurl+'/TenantUser/'+ user_guid +'/reset-password', { newPassword });
  } else {
    return from([]);
  }
  }
  // All role_guids a user currently holds (tenant-level AND workspace-level). The Users grid
  // only carries tenant-level roles, so this is used on edit to bind the user's WS-level roles
  // too - otherwise a user added from Workspace level shows an empty role section here.
  public getUserRoles(user_guid): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_View') || this.globals.workspaceActions.includes('TenantUsers_Edit')) {
    return this.http.get(environment.serviceurl+'/TenantUser/'+ user_guid +'/roles');
  } else {
    return from([]);
  }
  }
  // Count of tenants the CURRENT user can access. Not gated on a TenantUsers_* action -
  // every logged-in user (including non-admins) needs it to know whether the topbar's
  // Switch Tenant button should be enabled (>1 tenant) or disabled (single tenant).
  public getMyTenantCount(): Observable<any>{
    return this.http.get(environment.serviceurl+'/TenantUser/MyTenantCount');
  }
  public getActivationLink(user_guid): Observable<any>{
    if (this.globals.workspaceActions.includes('TenantUsers_Create') || this.globals.workspaceActions.includes('TenantUsers_Edit')) {
    return this.http.post(environment.serviceurl+'/TenantUser/'+ user_guid +'/activation-link', {});
  } else {
    return from([]);
  }
  }
}
